"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteCookies = void 0;
/**
 * Deletes all cookies for the specified domains.
 *
 * @param {string | string[]} domains - The domain or array of domains for which the cookies should be deleted.
 */
const deleteCookies = (domains) => {
    const allCookiesString = document.cookie;
    const cookiesArray = allCookiesString.split('; ');
    // Ensure domains is an array
    const domainArray = Array.isArray(domains) ? domains : [domains];
    /**
     * Deletes a specific cookie by name for a given domain.
     *
     * @param {string} name - The name of the cookie to delete.
     * @param {string} domain - The domain for which the cookie should be deleted.
     */
    const deleteCookie = (name, domain) => {
        document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; domain=${domain}`;
    };
    cookiesArray.forEach(cookie => {
        const [name] = cookie.split('=');
        domainArray.forEach(domain => {
            deleteCookie(name, domain);
        });
    });
};
exports.deleteCookies = deleteCookies;
//# sourceMappingURL=deleteCookies.js.map